import { Badge } from '@/components/ui/badge';
import { formatUsage, getUsageLevel } from '@/hooks/useProducerUsage';
import { cn } from '@/lib/utils';

interface UsageBadgeProps {
  used: number;
  limit: number | null;
  label: string;
  className?: string;
}

/**
 * Compact inline usage indicator: "Produkter: 2 / 3"
 * Shows amber when near limit, soft red at limit.
 */
export function UsageBadge({ used, limit, label, className }: UsageBadgeProps) {
  const level = getUsageLevel(used, limit);

  return (
    <Badge
      variant="outline"
      className={cn(
        'font-normal gap-1',
        level === 'near' && 'border-amber-300 text-amber-700 dark:border-amber-700 dark:text-amber-400',
        level === 'at' && 'border-amber-400 text-amber-800 dark:border-amber-600 dark:text-amber-300',
        className,
      )}
    >
      {label}: {formatUsage(used, limit)}
    </Badge>
  );
}
